import { cn } from "@/lib/utils"

interface DecorativeLineProps {
  className?: string
}

export function DecorativeLine({ className }: DecorativeLineProps) {
  return (
    <div
      className={cn("h-1 w-48 rounded-full", className)}
      style={{
        background:
          "linear-gradient(90deg, transparent 0%, #FEE685 30%, #FFD700 50%, #FEE685 70%, transparent 100%)",
      }}
    />
  )
}
